var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fe:messanger"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2558 19.2186L13.8425 15.672L7.2665 19.308L14.4745 11.66L17.8878 15.2066L24.4612 11.5706L17.2545 19.2186H17.2558ZM15.8652 2.66797C8.57584 2.66797 2.6665 8.1933 2.6665 15.0106C2.6665 18.888 4.5785 22.348 7.5705 24.6106V29.3346L12.0745 26.836C13.2745 27.172 14.5478 27.3533 15.8652 27.3533C23.1558 27.3533 29.0652 21.8266 29.0652 15.0106C29.0652 8.1933 23.1558 2.66797 15.8652 2.66797Z",
    fill: "#0295FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.3f8336a59fbbd1023eda020ce729ae60.svg";
export { ForwardRef as ReactComponent };